import { IntersectionOptions } from "react-intersection-observer"

// Spring animation values approximating Framer Motion spring
// Mass: 1, Stiffness: 44.44, Damping: 10
export const transitionTime = 1.2 // Longer duration for spring-like effect
export const delayTime = 0.2
// Custom cubic-bezier that approximates a spring with the given values
export const transitionEase = "cubic-bezier(0.34, 1.56, 0.64, 1)"

export const transitionUpValue = "50px"

// Alternative spring-like easing options
export const springEasing = {
  // Luxury, HB style - smooth and elegant
  luxury: "cubic-bezier(0.34, 1.56, 0.64, 1)",
  // More subtle spring
  gentle: "cubic-bezier(0.25, 0.8, 0.25, 1)",
  // Bouncy spring
  bouncy: "cubic-bezier(0.68, -0.55, 0.265, 1.55)",
}

export const useInViewConfig: IntersectionOptions = {
  triggerOnce: true,
  threshold: 0.3,
  rootMargin: "300px 0px 0px 0px",
}

export const styleObjectToCss = (styles: Record<string, any>): string => {
  return Object.entries(styles)
    .map(([key, value]) => {
      const cssKey = key.replace(/([A-Z])/g, "-$1").toLowerCase() // converts camelCase to kebab-case
      return `${cssKey}: ${value};`
    })
    .join(" ")
}

export const useInViewConfigInfinity: IntersectionOptions = {
  triggerOnce: false,
  threshold: 0,
  rootMargin: "300px 0px 0px 0px",
}
